import { Phone, Mail, MapPin, Facebook } from "lucide-react";
import { Logo } from "./Logo";
import { Link } from "react-router-dom";

export function Footer() {
  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Services", href: "/#services" },
    { name: "Projects", href: "/projects" },
    { name: "Contact", href: "/#contact" },
  ];

  return (
    <footer className="bg-slate-950 text-slate-400 border-t border-slate-800">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-10">
          {/* Brand with Logo component */}
          <div>
            <div className="mb-4">
              <Logo white className="h-32 w-32 md:h-40 md:w-40" />
            </div>
            <p className="text-sm leading-relaxed max-w-xs mb-5">
              Licensed & insured commercial electricians serving Greater New Orleans since 2008.
            </p>
            <div className="flex gap-3">
              <a href="https://www.facebook.com/Power1Electric" target="_blank" rel="noopener noreferrer"
                className="bg-slate-800 hover:bg-blue-600 p-2 rounded-lg transition-colors">
                <Facebook className="h-4 w-4 text-white" />
              </a>
              <a href="tel:5042872940" className="bg-slate-800 hover:bg-[#2557C7] p-2 rounded-lg transition-colors">
                <Phone className="h-4 w-4 text-white" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2 text-sm">
              {navLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="hover:text-[#5B8DEF] transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2"><MapPin className="h-3.5 w-3.5 text-[#5B8DEF] shrink-0" /> 918 25th St, Kenner, LA 70062</li>
              <li><a href="tel:5042872940" className="flex items-center gap-2 hover:text-[#5B8DEF] transition-colors"><Phone className="h-3.5 w-3.5 text-[#5B8DEF] shrink-0" /> (504) 287-2940</a></li>
              <li><a href="mailto:Contact@power-one-electric.com" className="flex items-center gap-2 hover:text-[#5B8DEF] transition-colors"><Mail className="h-3.5 w-3.5 text-[#5B8DEF] shrink-0" /> Contact@power-one-electric.com</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800/60 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-slate-600">
          <span>© {new Date().getFullYear()} Power One Electric LLC. All rights reserved.</span>
          <span className="text-[#5B8DEF] font-semibold">Licensed & Insured — New Orleans, LA</span>
        </div>
      </div>
    </footer>
  );
}
